import Name from './Name.jsx';
import Token from './Token.jsx';
import Utilities from './Utilities.jsx';

const Kit = {
    Context: {
        Global: { ...Name.Stylesheet }
    },

    Type: {
        Global: 'global'
    },

    _adjustStyleForInlineAttributes: (style, content) => {
        let _style = style;
        const attributes = ['font-size:', 'line-height:'];
        const startIndex = content.indexOf('<span');
        if (startIndex < 0) {
            return _style;
        }
        const upperLimit = content.indexOf('>', startIndex);
        attributes.forEach(attribute => {
            const index = content.indexOf(attribute);
            if (index < 0 || index > upperLimit) {
                return;
            }
            const endIndex = content.indexOf(';', index);
            if (endIndex < 0) {
                return;
            }
            _style += `${content.substring(index, endIndex)};`;
        })
        return _style;
    },

    initialize: (styleguide, fonts, existingKit) => {
        const kit = existingKit || {};
        if (!kit[Kit.Type.Global]) {
            kit[Kit.Type.Global] = {};
        }
        const kits = [
            Kit.Context.Global.Header1,
            Kit.Context.Global.Header2,
            Kit.Context.Global.Header3,
            Kit.Context.Global.Header4,
            Kit.Context.Global.Paragraph
        ];
        let updateKit = false;
        kits.forEach((k) => {
            if (!kit[Kit.Type.Global][k]) {
                kit[Kit.Type.Global][k] = Kit.Defaults[k](styleguide, fonts);
                updateKit = true;
            }
        });
        return { kit, updateKit }
    },

    updateDesign: (design, kit) => {
        let _design = design;
        if (!_design || !kit) {
            return _design;
        }
        const regExp = new RegExp(`<p class=\"(h\\d|p)\"( style=\"(.+?)\")?>`, 'g');
        let matches = _design.matchAll(regExp);
        if (matches) {
            matches = [...matches];
            for (let i = matches.length - 1; i >= 0; i--) {
                const match = matches[i];
                if (match.length < 2) {
                    continue;
                }
                const matchType = match[1];
                let style = kit[matchType] || '';
                if (match.length < 4 || !match[3]) {
                    const content = _design.substring(match.index + match[0].length);
                    style = Kit._adjustStyleForInlineAttributes(style, content);
                    _design = _design.substring(0, match.index) + match[0].substring(0, match[0].length - 1) + ` style="${style}">` + content;
                } else {
                    const index = _design.indexOf(match[3], match.index);
                    const content = _design.substring(index);
                    style = Kit._adjustStyleForInlineAttributes(style, content);
                    _design = _design.substring(0, index) + style + content;
                }
            }
        }
        return _design;
    }
}
Kit.Defaults = {
    [Kit.Context.Global.Header1]: (styleguide, fonts) => ({ "design": Utilities.wrapTextForEditor({ tag: Kit.Context.Global.Header1, text: `{${Token.HeaderText}}`, textExtras: `style="${styleguide && styleguide.BodyHeaderText ? `color:${styleguide.BodyHeaderText};` : ''}font-family:${fonts.header};font-size:16px;line-height:22px;vertical-align:middle;"`, token: Token.HeaderText }) }),
    [Kit.Context.Global.Header2]: (styleguide, fonts) => ({ "design": Utilities.wrapTextForEditor({ tag: Kit.Context.Global.Header2, text: `{${Token.ParagraphText}}`, textExtras: `style="${styleguide && styleguide.BodyText ? `color:${styleguide.BodyText};` : ''}font-family:${fonts.body};font-size:14px;font-weight:bold;line-height:20px;vertical-align:middle;"`, token: Token.ParagraphText }) }),
    [Kit.Context.Global.Header3]: (styleguide, fonts) => ({ "design": Utilities.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.ParagraphText}}`, textExtras: `style="${styleguide && styleguide.BodyText ? `color:${styleguide.BodyText};` : ''}font-family:${fonts.body};font-size:14px;font-style:italic;line-height:20px;vertical-align:middle;"`, token: Token.ParagraphText }) }),
    [Kit.Context.Global.Header4]: (styleguide, fonts) => ({ "design": Utilities.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: `{${Token.ParagraphText}}`, textExtras: `style="${styleguide && styleguide.BodyText ? `color:${styleguide.BodyText};` : ''}font-family:${fonts.body};font-size:12px;line-height:18px;vertical-align:middle;"`, token: Token.ParagraphText }) }),
    [Kit.Context.Global.Paragraph]: (styleguide, fonts) => ({ "design": Utilities.wrapTextForEditor({ tag: Kit.Context.Global.Paragraph, text: `{${Token.ParagraphText}}`, textExtras: `style="${styleguide && styleguide.BodyText ? `color:${styleguide.BodyText};` : ''}font-family:${fonts.body};font-size:14px;line-height:20px;vertical-align:middle;"`, token: Token.ParagraphText }) })
}

export default Kit;